module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (39).37d6878f.png";